import * as Immutable from 'immutable';

import { AccountStore } from './AccountReducer.types';

export const initialMetadata = {
  defaultCountry: undefined,
  country: [
    { value: 'US', label: 'United States of America' },
    { value: 'VN', label: 'Vietnam' },
    { value: 'SG', label: 'Singapore' },
  ],
  degree: [],
  university: [],
  gender: [],
  graduationYear: { maxValue: 0, minValue: 0 },
};

export const initialBasicDataField = {
  email: { value: '', valid: false, errors: [] },
  firstName: { value: '', valid: false, errors: [] },
  lastName: { value: '', valid: false, errors: [] },
  fullName: { value: '', valid: false, errors: [] },
  telephone: { value: '', valid: false, errors: [] },
  allowSMS: { value: '', valid: false, errors: [] },
  password: { value: '', valid: false, errors: [] },
  confirmation: { value: '', valid: false, errors: [] },
  captcha: { value: '', valid: true, errors: [] },
  agree: { value: null, valid: false, errors: [] },
  agreePrivacyPolicy: { value: null, valid: false, errors: [] },
  agreeCompetition: { value: true, valid: true, errors: [] },
  country: { value: '', valid: false, errors: [] },
  street: { value: '', valid: true, errors: [] },
  gender: { value: '', valid: false, errors: [] },
  referrer: { value: '', valid: true, errors: [] },
  city: { value: '', valid: true, errors: [] },
  state: { value: '', valid: true, errors: [] },
  postalCode: { value: '', valid: true, errors: [] },
  university: { value: '', valid: false, errors: [] },
  degree: { value: '', valid: true, errors: [] },
  graduationYear: { value: '', valid: true, errors: [] },
  major: { value: '', valid: true, errors: [] },
  gpa: { value: '', valid: true, errors: [] },
  maxGPA: { value: '', valid: true, errors: [] },
  stem: { value: null, valid: true, errors: [] },
  presently_employed: { value: null, valid: false, errors: [] },
  changeEmail: { value: '', valid: false, errors: [] },
  changeEmailPassword: { value: '', valid: false, errors: [] },
  workdayPassword: { value: '', valid: false, errors: [] },
  brainLabsPassword: { value: '', valid: false, errors: [] },
  accessTokenPassword: { value: '', valid: false, errors: [] },
  accessToken: { value: '', valid: false, errors: [] },
};

export const initialDataFieldEmployer = {
  employer: { value: '', valid: false, errors: [] },
  title: { value: '', valid: false, errors: [] },
  business: { value: '', valid: false, errors: [] },
  description: { value: '', valid: false, errors: [] },
  nonPublicInformation: { value: null, valid: false, errors: [] },
  participationPermitted: { value: null, valid: false, errors: [] },
  finance: { value: null, valid: false, errors: [] },
};

export const initialDataFieldRecruitment = {
  englishProficiency: { value: '', valid: true, errors: [] },
  codingProficiency: { value: '', valid: true, errors: [] },
  roleInterest: { value: [], valid: true, errors: [] },
};

export const initialDataFieldEmployerFinance = {
  investmentAdvisory: { value: null, valid: false, errors: [] },
  brokerage: { value: null, valid: true, errors: [] },
  fundamentalResearch: { value: null, valid: false, errors: [] },
  proprietaryTrading: { value: null, valid: false, errors: [] },
  serviceEngagement: { value: null, valid: false, errors: [] },
  exposureStatus: { value: null, valid: false, errors: [] },
  employerServices: { value: '', valid: false, errors: [] },
  exposureDetails: { value: '', valid: false, errors: [] },
};

export const initialDataFields = {
  ...initialBasicDataField,
  ...initialDataFieldEmployer,
  ...initialDataFieldEmployerFinance,
  ...initialDataFieldRecruitment,
};
// @ts-ignore
export const initialAccountData: AccountStore = Immutable.fromJS({
  terms: {
    terms_understand: false,
    terms_compensation: false,
    terms_authority: false,
  },
  competition: {},
  verified: false,
  referrer: false,
  submitted: false,
  metadata: initialMetadata,
  dataFields: initialDataFields,
  isFetching: false,
  locked: false,
  approved: false,
  termsAccepted: false,
  hasUserOptions: false,
  isValidToSubmit: false,
  userOptionsFailure: false,
  isAcceptingAgreements: false,
  isFetchUserOptions: false,
  countryOptionsMap: {},
  dirtyFields: [],
  recertificationProgress: [],
  isAccountDetailsAgree: false,
  currentForm: 'basic-details',
  accountType: '',
  verifiedType: 'EMAIL_VERIFIED',
  accountVerifyEmail500: false,
  fetchingToken: false,
  changedEmail: false,
  createForm: {
    'basic-details': {
      fields: [
        'email',
        'telephone',
        'firstName',
        'lastName',
        'fullName',
        'country',
        'gender',
        'university',
        'referrer',
        'password',
        'confirmation',
        'captcha',
        'agree',
        'agreePrivacyPolicy',
        'presently_employed',
      ],
      valid: false,
    },
  },
  changeEmailForm: {
    changeEmail: {
      fields: ['changeEmail', 'changeEmailPassword'],
      valid: false,
    },
  },
  updateForm: {
    'basic-details': {
      fields: ['firstName', 'lastName', 'fullName', 'telephone', 'allowSMS', 'gender', 'publicName', 'publicPhoto'],
      valid: false,
    },
    location: {
      fields: ['country', 'street', 'city', 'state', 'postalCode'],
      valid: false,
    },
    education: {
      fields: ['university', 'degree', 'graduationYear', 'major', 'gpa', 'maxGPA'],
      valid: false,
    },
    recruitment: {
      fields: ['englishProficiency', 'codingProficiency', 'roleInterest'],
      valid: false,
    },
    employment: {
      fields: ['presently_employed'],
      valid: false,
    },
    'access-token': {
      valid: false,
    },
    'recertify-account': {
      fields: ['agree'],
      valid: false,
    },
  },
});
